import { InjectionToken, Type } from '@angular/core';
import { TopicsTreeMode } from '../../topics-tree-mode';
import { AssetTreeAdminModeBadgeType, AssetTreeStudentModeBadgeType } from '../asset-tree-toolbar';
import { TopicLevel2BadgeComponent } from './abstract-topic-level-2-badge.component';

export type TopicsTreeBadgeComponents<T extends TopicsTreeMode> = Record<
  T extends 'student' ? AssetTreeStudentModeBadgeType : AssetTreeAdminModeBadgeType,
  Type<TopicLevel2BadgeComponent>
>;

export const TOPICS_TREE_BADGE_COMPONENTS = new InjectionToken<TopicsTreeMode>('topics_tree_mode_badge_components');
